import { GeneralModel } from "./general.model";

export class Report extends GeneralModel {}



// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/report.model.ts